module.exports = __webpack_public_path__ + "assets/7f5573d290b81384de597fb7195f25d1.png";